module.exports = __webpack_public_path__ + "img/cancel.cad70081.svg";